import api from "./axiosInstance";

export const getEmailsLogs = async (limit = 10, offset = 0, search = "", status = "") => {
  const params = new URLSearchParams({ limit, offset });
  if (search) params.append("search", search);
  if (status) params.append("status", status); 
  const res = await api.get(
    `api/v1/notifications/emails/?${params.toString()}`,
  );
  return res.data;
};

export const resendEmail = async (id, payload) => {
  const res = await api.post(`api/v1/notifications/emails/${id}/resend/`, payload);
  return res.data;
};

export const fetchStatusEmail = async (id) => {
  const res = await api.post(`api/v1/notifications/emails/${id}/fetch-status/`);
  return res.data;
};

export const getEmailsDashboard = async (range) => {
  const res = await api.get("api/v1/notifications/emails/dashboard/", {
    params: {
      range: range,
    },
  });
  return res.data;
};
